<section class="page__section -small-bottom">
    <calendar></calendar>
</section>
